import * as fabric from 'office-ui-fabric-react';
import React, { FC, useEffect, useState } from 'react';
import { stickyContainer } from '../Helpers';

interface ShowErrorModalProps {
    error: string | null;
    logout: boolean;
}

export const ShowErrorModal: FC<ShowErrorModalProps> = (props: ShowErrorModalProps) => {
    const [showHide, setShowHide] = useState(false);

    useEffect(() => {
        setShowHide(true);
    }, [props.error]);

    return (
        <fabric.Stack styles={stickyContainer}>
            <fabric.Modal isOpen={showHide} isModeless={true}>
                <fabric.Stack.Item className="unselectable" align="center" styles={{ root: { margin: '3vw' } }}>
                    <fabric.Stack horizontalAlign="center">
                        <fabric.Text variant={props.logout ? 'xLarge' : 'mega'}>Įvyko klaida</fabric.Text>
                    </fabric.Stack>

                    <fabric.Stack horizontalAlign="center" styles={{ root: { margin: '3vw' } }}>
                        <fabric.Text variant={props.logout ? 'xLarge' : 'xLarge'}>
                            {props.error ? props.error : 'Įvyko neatpažinta klaida.'}
                        </fabric.Text>
                    </fabric.Stack>

                    {props.logout && (
                        <fabric.Stack horizontalAlign="center">
                            <fabric.Stack.Item styles={{ root: { margin: '1vw' } }}>
                                <fabric.PrimaryButton
                                    onClick={() => {
                                        localStorage.removeItem('locationId');
                                        window.location.reload(false);
                                    }}
                                >
                                    Baigti darbą
                                </fabric.PrimaryButton>
                            </fabric.Stack.Item>
                        </fabric.Stack>
                    )}
                </fabric.Stack.Item>
            </fabric.Modal>
        </fabric.Stack>
    );
};
